import React, { Component } from 'react'
import store from './store'
import { observer } from 'mobx-react'
import { Button, Checkbox } from 'hljd'
import styles from '../style.module.less'
import { getObjValue } from '@hlj/hlj-utils'
import { HeaderView } from '@merchant-backend/common-components'
import { PRIVILEGE_ORDER_REFUND } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    store.getStatus()
    store.getPromise()
  }

  render() {
    const { list, ids } = store
    let header = [
      <a href={`#/localMerchant/marketingTools?key=${PRIVILEGE_ORDER_REFUND}`}>
        订单可退
      </a>,
      '设置订单可退'
    ]

    return (
      <HeaderView header={header} title="设置订单可退">
        {/*<p className={styles.title}>*/}
        {/*<a href='#/localMerchant/marketingTools'>订单可退 > </a>*/}
        {/*<span>设置订单可退</span>*/}
        {/*</p>*/}
        <div className={styles.box}>
          <div className={styles.service}>
            <span>请选择服务内容</span>
            <small>(至少选择1项)</small>
            <Button
              type="primary"
              style={{ float: 'right', marginTop: 16 }}
              onClick={store.savePromise}
            >
              保存
            </Button>
          </div>
          <div className={styles.serviceDetail}>
            <ul className={styles.promiseUl}>
              {(list || []).map(({ id, detail, image_path, main }, index) => (
                <li key={id}>
                  <Checkbox
                    checked={getObjValue(ids[index], 'status') == 1}
                    onChange={store.changeCheck(id, index)}
                  >
                    <span style={{ float: 'right' }}>
                      <img src={image_path} />
                      <div>
                        <p
                          style={{
                            color:
                              getObjValue(ids[index], 'status') == 1
                                ? '#448afc'
                                : '#333'
                          }}
                        >
                          {main}
                        </p>
                        <p
                          style={{
                            color:
                              getObjValue(ids[index], 'status') == 1
                                ? '#448afc'
                                : '#666'
                          }}
                        >
                          {detail}
                        </p>
                      </div>
                    </span>
                  </Checkbox>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </HeaderView>
    )
  }
}
